import axios from './axios_interceptors'
import config from '@/services/config'

export default {

  updateCampaignContent(campaign_uuid, content_uuid, data) {
    return axios.post(`${config.urlCore}/api/v1/campaign/${campaign_uuid}/manage/influencer-update/${content_uuid}`,
      data)
      .then(response => response.data.response)
      .catch(error => {
        console.log(error)
        return error.response
      })
  },
  getMetrics(campaign_uuid, data) {
    return axios.post(`${config.urlCore}/api/v1/campaign/${campaign_uuid}/content/stats`,
      data)
      .then(response => response.data.response)
      .catch(error => {
        console.log(error)
        return error.response
      })
  },
  getMetricsV2(data) {
    return axios.post(`${config.urlCore}/api/v3/management/estimate-metrics/`,
      data)
      .then(response => response.data.response)
      .catch(error => {
        console.log(error)
        return error.response
      })
  },
  addContent(campaign_uuid, data) {
    return axios.post(`${config.urlCore}/api/v1/campaign/${campaign_uuid}/manage/add/`,
      data,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` }
      })
      .then(response => response.data.response)
      .catch(error => {
        return error.response
      })
  },
  addContentNoSession(campaign_uuid, data) {
    return axios.post(`${config.urlCore}/api/v1/campaign/${campaign_uuid}/manage/influencer-add/`,data)
      .then(response => response.data.response)
      .catch(error => {
        return error.response
      })
  },
  getInvitation(slug, network, username) {
    return axios.get(`${config.urlCore}/api/v1/campaign/external/${slug}/${network}/${username}/`, {
    }).then(response => response.data.response)
      .catch(error => {
        if (error.response.status === 401)
          return error.response
      })
  },
  accpetTerms(slug, network, username) {
    return axios.get(`${config.urlCore}/api/v1/campaign/external/accept-terms/${slug}/${network}/${username}/`, {
    }).then(response => response.data.response)
      .catch(error => {
        if (error.response.status === 401)
          return error.response
      })
  },
  contents(campaign_influencer_uuid, page = 1, size_page = 10) {
    const url = `${config.urlCore}/api/v3/invitation-link/campaign-influencer/${campaign_influencer_uuid}/contents?page=${page}&size_page=${size_page}`
    
    return axios.get(url, {
    }).then(response => response.data.response)
      .catch(error => {
        if (error.response.status === 401)
          return error.response
      })
  },
  updatePaymentData(data) {
    return axios.post(`${config.urlCore}/api/v1/campaign/external/update/payment-data/`,
      data
    ).then(response => response.data.response)
      .catch(error => {
        console.log(error)
        return error.response
      })
  },
  requestMoneyInvitation(data) {
    return axios.post(`${config.urlCore}/api/v3/invitation-link/request-money/`,
      data
    ).then(response => response.data.response)
      .catch(error => {
        console.log(error)
        return error.response
      })
  },
  changeInfluencerStatus(campaign_influencer_uuid, status) {
    return axios.post(`${config.urlCore}/api/v1/campaign/external/update/status/${campaign_influencer_uuid}`,
      {status}
    ).then(response => response.data.response)
      .catch(error => {
        console.log(error)
        return error.response
      })
  },
  validateSession(slug, network, username) {
    return axios.get(`${config.urlCore}/api/v1/campaign/external/validate-session/${slug}/${network}/${username}/`, {
      headers: {Authorization: `Bearer ${localStorage.getItem('accessToken')}`}
    }).then(response => response.data.response)
      .catch(error => {
        if (error.response.status === 401)
          return error.response
      })
  },
  register(data) {
    return axios.post(`${config.urlCore}/api/v1/campaign/external/register/`,
      data
    ).then(response => response.data.response)
      .catch(error => {
        console.log(error)
        return error.response
      })
  },
  loginInvitation(data) {
    return axios.post(`${config.urlCore}/api/v3/invitation-link/login/`,
      data
    ).then(response => response.data.response)
      .catch(error => {
        console.log(error)
        return error.response
      })
  },
  readyToPay(campaign_influencer_uuid) {
    return axios.get(`${config.urlCore}/api/v3/invitation-link/campaign-influencer/${campaign_influencer_uuid}/ready-to-pay/`,
    ).then(response => response.data.response)
      .catch(error => {
        console.log(error)
        return error.response
      })
  },
}